<template>
    <v-btn text class="custom-btn custom-btn--back" color="secondary"
           @click="navigateBack">
        <v-img :src="require(`@/assets/img/icons/chevron.svg`)">
        </v-img>
        Back
    </v-btn>
</template>

<script>
    export default {
        name: "BackButton",
        props: ['communityName', 'formState', 'navigateTo', 'shouldClose', 'navigatedFrom', 'beingEdited'],
        methods: {
            navigateBack: function () {
                if (this.shouldClose) {
                    this.closeDialog(this.navigateTo)
                } else {
                    this.$router.push({
                        name: this.navigateTo,
                        params: {
                            beingEdited: this.beingEdited,
                            communityName: this.communityName,
                            navigatedFrom: this.navigatedFrom || this.$route.name,
                            formState: this.formState,
                        }
                    });
                }
            },
            closeDialog(componentName) {
                this.$router.push({name: componentName, params: {dialog: 'false'}});
            }
        },
    }
</script>

<style scoped>

</style>
